import AiTicketTemplateDialog from './AITicketTemplateDialog';

export default AiTicketTemplateDialog;
export { AiTicketTemplateDialog };
